import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import VueGtag from "vue-gtag-next";

import { library } from '@fortawesome/fontawesome-svg-core'
import { faCaretSquareDown, faCaretSquareUp } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import store from './store'
library.add(faCaretSquareDown, faCaretSquareUp)


createApp(App).use(store).use(VueGtag, {  property: {    id: "G-3LG0R87MZJ"  }}).use(router).component('font-awesome-icon', FontAwesomeIcon).mount('#app')
